import { type FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import { ReactComponent as AutoAwesomeIcon } from "../../../../assets/images/auto-awesome.svg";
import "./style.less";

export interface AutoProdAssignmentProps {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  className?: string;
}

const AutoProdAssignment: FC<AutoProdAssignmentProps> = ({
  disabled = false,
  loading = false,
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      className={`rd-auto-prod-assignment ${className ?? ""}`}
      data-testid="auto-prod-assignment"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      icon={<AutoAwesomeIcon className="rd-auto-prod-assignment__icon" />}
    >
      {formatTranslation(t("newRatesAndDosage.autoProdAssignment.label"))}
    </Button>
  );
};

export default AutoProdAssignment;
